
import Vue from 'vue'
import VueRouter from 'vue-router';

const routes = [];

const router = new VueRouter({
    mode: 'history',
    routes,
});

Vue.use(VueRouter);

export default {
  router,
  data() {
    return {
      router: null,
      selectedTabSlug: '',
    };
  },

  props: {
    defaultTabIndex: {
      type: Number,
      default: 0,
    },
    chevronRight: {
      type: String,
      default: '<svg width="70px" height="116px" viewBox="0 0 70 116" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M68.1433888,62.5079891 L16.8092509,114.13264 C14.3334612,116.622453 10.3195809,116.622453 7.84405535,114.13264 L1.8567807,108.111451 C-0.614782755,105.625887 -0.619537286,101.597505 1.84621508,99.1060979 L42.5294122,57.9998672 L1.84621508,16.8939021 C-0.619537286,14.4024947 -0.614782755,10.3741128 1.8567807,7.88854934 L7.84405535,1.86736022 C10.3198451,-0.622453408 14.3337254,-0.622453408 16.8092509,1.86736022 L68.1431247,53.4920109 C70.6189144,55.9815589 70.6189144,60.0181755 68.1433888,62.5079891 Z" id="icon-chevron-right" fill="#000000" fill-rule="nonzero"></path></g></svg>',
    },
  },

  computed: {
    hasContent: function(){
      return this.$slots.research || this.$slots.bio || this.$slots.publications;
    },
    params: function(){
      var params = {};

      if(this.selectedTabSlug.length) {
        params.tab = this.selectedTabSlug;
      }

      return params;
    },
  },

  watch: {
    selectedTabSlug: function (newValue, oldValue) {
      //this.updateRoutes();
    },
    $route (to, from){

      console.log(to.path, to.query);

      if(to.query.tab) {
        this.didSelectTab(to.query.tab);
      }

//       var projectSlug = to.path.substring(to.path.lastIndexOf('/') + 1);
//
//       if(to.path == this.baseUrl) {
//           this.selectedProjectSlug = '';
//       } else if(projectSlug.length) {
//           this.selectedProjectSlug = projectSlug;
//       }
//
//       if(this.selectedProject) {
//           document.title = this.selectedProject.title;
//       } else {
//           document.title = this.defaultPageTitle;
//       }

    },
  },

  methods: {
    makeUrlForTab: function(slug) {
      return window.location.pathname+'?tab='+slug;
    },
    updateRoutes: function() {
      if(this.router != null) {
        this.router.push({ path: window.location.pathname, query: this.params}).catch(err => {  }); // eslint-disable-line
      }
    },
    didSelectTab: function (tabSlug) {
      this.selectedTabSlug = tabSlug;
    },
    selectFirstTab: function () {
      if(!this.hasContent) return;

      if(this.$slots.overview) {
        this.selectedTabSlug = 'overview';
        return;
      }

      if(this.$slots.members) {
        this.selectedTabSlug = 'members';
        return;
      }

      if(this.$slots.themes) {
        this.selectedTabSlug = 'themes';
        return;
      }

      if(this.$slots.research) {
        this.selectedTabSlug = 'research';
        return;
      }

      if(this.$slots.bio) {
        this.selectedTabSlug = 'bio';
        return;
      }

      if(this.$slots.publications) {
        this.selectedTabSlug = 'publications';
        return;
      }

    },
  },

  components: {},

  created() {},

  destroyed() {},

  mounted() {
    var self = this,
    urlParams = new URLSearchParams(window.location.search);

    if(self.hasContent && urlParams.get('tab')) {
      self.selectedTabSlug = urlParams.get('tab');
    } else {
      self.selectFirstTab()
    }

    // self.router  = new VueRouter({mode: 'history'});

  },
};



// WEBPACK FOOTER //
// ./scripts/vue/TabbedContent.vue